import useStyles from "./styles";
import * as WebAPI from "../../actions/richiestaAbbonamento";
import Head from "../../Layout/Head/Head";
import Grid from "@material-ui/core/Grid";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Button from "@material-ui/core/Button";
import React from "react";
import Typography from "@material-ui/core/Typography";
import DataItem from "../../Components/DataItem";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import Box from '@material-ui/core/Box';
import { useHistory } from "react-router-dom";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import Divider from "@material-ui/core/Divider";
import CircularProgress from '@material-ui/core/CircularProgress';
import pdf from '../../files/RegolamentoMiliscola2021.pdf'


import {
    BeachAccess as HomeIcon
} from "@material-ui/icons";

// Stepper Steps
function getSteps() {
    return ["Introduzione","Dati Titolare", "Turni", "Familiari", "Verifica ed Invio"];
  }

function getStepContent(handleChange, step, classes, 
    selectedStatus, selectStatus, 
    selectedFFAA, selectFFAA, 
    selectedAllFFAA, selectAllFFAA, 
    selectTurniAA, selectedTurnoAA, 
    selectTurniAEAM, selectedTurno1Altro, 
    selectTurniAEAMpr, selectedTurno1Altropr, 
    selectedTurno2Altro, selectedTurno2Altropr, 
    selectNAbbonamenti, selectedNAbbonamenti, 
    selectGP, selectedGP1, selectedGP2, selectedGP3, selectedGP4, selectedGP5, selectedGP6, 
    setNome, setCognome, setCitta, setVia, setCivico, setCap, 
    setMobile, setEmail, setTelUfficio, setGrado, setSede,
    setQualifica, setNomeConiugeDefunto, setCognomeConiugeDefunto, setDataCongedo, 
    setNomeP1, setCognomeP1, setDataNascitaP1,
    setNomeP2, setCognomeP2, setDataNascitaP2,
    setNomeP3, setCognomeP3, setDataNascitaP3,
    setNomeP4, setCognomeP4, setDataNascitaP4,
    setNomeP5, setCognomeP5, setDataNascitaP5,
    setNomeP6, setCognomeP6, setDataNascitaP6,
    nome, cognome, citta, via, civico, 
    cap, mobile, email, grado, qualifica, sede, ufficio, 
    nomeConiugeDefunto, cognomeConiugeDefunto, dataCongedo,
    nomep1, cognomep1, datanascitap1, notep1, setNoteP1,
    nomep2, cognomep2, datanascitap2, notep2, setNoteP2,
    nomep3, cognomep3, datanascitap3, notep3, setNoteP3,
    nomep4, cognomep4, datanascitap4, notep4, setNoteP4,
    nomep5, cognomep5, datanascitap5, notep5, setNoteP5,
    nomep6, cognomep6, datanascitap6, notep6, setNoteP6,
    numeroCmd, setNumeroCmd,
    tipoDocumento, setTipoDocumento,
    numeroDocumento, setNumeroDocumento,
    selectedCabina) {
    switch (step) {
        case 0:
        return (
            <Grid container item xs={12} alignItems="center">
                <Grid item xs={12}>
                    
                    <Typography gutterBottom variant="h6" component="h6">
                        {"PREMESSA"}
                    </Typography>
                    <Typography component="div">
                        <Box textAlign="justify" m={1}>
                        La Forza Armata, considerate le specifiche peculiarità di cui il personale militare deve essere in possesso (efficienza psico-fisica, elevate capacità operative), a fronte dei compiti di istituto e della normativa relativa agli interventi di promozione umana e sociale per il personale militare e civile del Ministero della Difesa, dispone di strutture in ambiente marino atte a conseguire gli obiettivi prefissati. 
                        </Box>
                        <Box textAlign="justify" m={1}>
                        Il Distaccamento Straordinario A.M. di “Miliscola”, situato lungo il litorale di Bacoli, rientra nel comprensorio operativo, cioè nell’insieme organico delle strutture che servono per il conseguimento degli obiettivi dell’Istituto ed è funzionale all’attività addestrativa alla sopravvivenza in mare del personale frequentatore di corso (attività svolta nell’ambito del Nucleo Sopravvivenza in Mare del Comando Corsi). La struttura, inoltre, fa parte dell’Organismo di Protezione Sociale “Sala Convegno Unica” dell’Accademia Aeronautica.
Presso il Distaccamento è operativo uno stabilimento balneare la cui gestione dei servizi rivolti agli utenti, mediante esperimento di apposita procedura negoziale ai sensi del D.Lgs. 50/2016 e nel rispetto della Direttiva SMD-G-023, è stata affidata in concessione alla Ditta “PIANELLI S.r.l.”, che ne assicurerà il regolare funzionamento.
         
                        </Box>
                        <Box textAlign="justify" m={1}>
                        Le attività di presidio sono garantite da personale militare e civile in servizio presso l’Accademia Aeronautica, alle dipendenze del T.Col. GArs Domenico FAPARELLI, che, in qualità di Capo Distaccamento delegato dal Comandante dell’Accademia Aeronautica, opererà durante il periodo di apertura agli utenti e provvederà a garantire il rispetto del presente Regolamento e a gestire le ulteriori fattispecie non previste dallo stesso, in autonomia ovvero sentito il citato Comandante. Il Capo Distaccamento, in caso di assenza, è sostituito dal Sottufficiale più alto in grado tra gli addetti presenti.
                        </Box>
                    </Typography>

                    <Typography gutterBottom variant="h6" component="h6">
                        {"ABBONAMENTI"}
                    </Typography>
                    <Typography component="div">
                        <Box textAlign="justify" m={1}>
                        La stagione balneare, al fine di consentire la massima fruibilità, è suddivisa in 2 turni:
                        1° turno, dal 1° al 31 luglio;
                        2° turno, dal 1° al 31 agosto.
 </Box>
                        <Box textAlign="justify" m={1}>
                        Qualora si intenda prenotare uno specifico periodo di fruizione tramite l’acquisto di un abbonamento per l’ammissione ai turni sopraindicati è necessario compilare la presente richiesta strutturata in passaggi.</Box>
                        
                        <Box textAlign="justify" m={1}>
                        I dati e la documentazione richiesta sono quelli previsti dal REGOLAMENTO PER L’AMMISSIONE AL 
DISTACCAMENTO STRAORDINARIO A.M. DI “MILISCOLA” 2021
 </Box>


                    </Typography>
                    <Typography gutterBottom variant="h6" component="h6">
                        {"REGOLAMENTO"}
                    </Typography>
                    <Typography component="div">
                        <Box textAlign="justify" m={1}>
                        Puoi prendere visione del regolamento <a href={pdf} target="_blank">QUI</a>
 </Box>


                    </Typography>
                    
                   
                
                </Grid>
            </Grid>
        );
        case 1:
        return (
            <Grid container item xs={12} alignItems="center" spacing={2}>
                <Grid item xs={12}> 
                    <Typography  variant="h6" component="h6" >
                        {"ANAGRAFICA TITOLARE"}
                    </Typography>
                </Grid>
                  
            
             <Grid item xs={6}>
                <TextField
                key="nome"
                label="Nome"
                margin="normal"
                value={nome}
                fullWidth
                InputLabelProps={{
                    shrink: true,
                }}
                variant="outlined"
                onInput={ e => setNome(e.target.value)}
                />
             </Grid>
             <Grid item xs={6}>
                <TextField
                key="cognome"
                label="Cognome"
                margin="normal"
                value={cognome}
                fullWidth
                InputLabelProps={{
                    shrink: true,
                }}
                variant="outlined"
                onInput={ e => setCognome(e.target.value)}
                />
             </Grid>
           
             <Grid item xs={12}> 
                    <Typography  variant="h6" component="h6" >
                        {"RESIDENZA"}
                    </Typography>
                </Grid>
             <Grid item xs={3}>
                <TextField
                key="cittaDiResidenza"
                label="Città di Residenza"
                margin="normal"
                value={citta}
                fullWidth
                InputLabelProps={{
                    shrink: true,
                }}
                variant="outlined"
                onInput={ e => setCitta(e.target.value)}
                />
             </Grid>
             <Grid item xs={6}>
                <TextField
                key="indirizzo"
                label="Indirizzo"
                margin="normal"
                value={via}
                fullWidth
                InputLabelProps={{
                    shrink: true,
                }}
                variant="outlined"
                onInput={ e => setVia(e.target.value)}
                />
             </Grid>
             <Grid item xs={1}>
                <TextField
                key="civico"
                label="Civico"
                margin="normal"
                value={civico}
                fullWidth
                InputLabelProps={{
                    shrink: true,
                }}
                variant="outlined"
                onInput={ e => setCivico(e.target.value)}
                />
             </Grid>
             <Grid item xs={2}>
                <TextField
                key="cap"
                label="CAP"
                margin="normal"
                value={cap}
                fullWidth
                InputLabelProps={{
                    shrink: true,
                }}
                variant="outlined"
                onInput={ e => setCap(e.target.value)}
                />
             </Grid>
             <Grid item xs={12}> 
                    <Typography  variant="h6" component="h6" >
                        {"CONTATTI"}
                    </Typography>
                </Grid>
             <Grid item xs={3}>
                <TextField
                key="mobile"
                label="Cellulare"
                margin="normal"
                value={mobile}
                fullWidth
                InputLabelProps={{
                    shrink: true,
                }}
                variant="outlined"
                onInput={ e => setMobile(e.target.value)}
                />
             </Grid>
             <Grid item xs={3}>
                <TextField
                key="ufficio"
                label="Telefono Ufficio"
                margin="normal"
                value={ufficio}
                fullWidth
                InputLabelProps={{
                    shrink: true,
                }}
                variant="outlined"
                onInput={ e => setTelUfficio(e.target.value)}
                />
             </Grid>
             <Grid item xs={6}>
                <TextField
                key="email"
                label="E-Mail"
                margin="normal"
                value={email}
                fullWidth
                InputLabelProps={{
                    shrink: true,
                }}
                variant="outlined"
                onInput={ e => setEmail(e.target.value)}
                />
             </Grid>
             <Grid item xs={12}> 
                    <Typography  variant="h6" component="h6" >
                        {"STATUS"}
                    </Typography>
                </Grid>
             <Grid item xs={12}>
                <TextField
                    key="status"
                    name="status"
                    select
                    label="Stato"
                    fullWidth
                    margin="normal"
                    value={selectedStatus}
                    onChange={handleChange}
                    InputLabelProps={{
                    shrink: true,
                    }}
                    variant="outlined"
                >
                    {selectStatus.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                        {option.label}
                    </MenuItem>
                    ))}
                </TextField>
            </Grid>

            {selectedStatus === "militareinservizioMD" ? (
                <Grid container item xs={12} spacing={2}>
                     <Grid item xs={3}>
                         <TextField
                             key="forzaArmata"
                             name="forzaArmata"
                             select
                             label="Forza Armata"
                             fullWidth
                             margin="normal"
                             value={selectedFFAA}
                             onChange={handleChange}
                             InputLabelProps={{
                             shrink: true,
                             }}
                             variant="outlined"
                         >
                             {selectFFAA.map((option) => (
                             <MenuItem key={option.value} value={option.value}>
                                 {option.label}
                             </MenuItem>
                             ))}
                         </TextField>
                     </Grid>
                     <Grid item xs={2}>
                         <TextField
                         key="grado"
                         label="Grado"
                         margin="normal"
                         value={grado}
                         fullWidth
                         InputLabelProps={{
                             shrink: true,
                         }}
                         variant="outlined"
                         onInput={ e => setGrado(e.target.value)}
                         />
                     </Grid>
                     <Grid item xs={5}>
                         <TextField
                         key="sede"
                         label="Sede"
                         margin="normal"
                         value={sede}
                         fullWidth
                         InputLabelProps={{
                             shrink: true,
                         }}
                         variant="outlined"
                         onInput={ e => setSede(e.target.value)}
                         />
                     </Grid>
                     <Grid item xs={2}>
                         <TextField
                         key="cmd"
                         label="Numero CMD"
                         margin="normal"
                         value={numeroCmd}
                         fullWidth
                         InputLabelProps={{
                             shrink: true,
                         }}
                         variant="outlined"
                         onInput={ e => setNumeroCmd(e.target.value)}
                         />
                     </Grid>
                 </Grid>
            ) : null}
             {selectedStatus === "dipcivileinservizioMD" ? (
                <Grid container item xs={12} spacing={2}>
                     <Grid item xs={3}>
                         <TextField
                             key="forzaArmata"
                             name="forzaArmata"
                             select
                             label="Forza Armata"
                             fullWidth
                             margin="normal"
                             value={selectedFFAA}
                             onChange={handleChange}
                             InputLabelProps={{
                             shrink: true,
                             }}
                             variant="outlined"
                         >
                             {selectFFAA.map((option) => (
                             <MenuItem key={option.value} value={option.value}>
                                 {option.label}
                             </MenuItem>
                             ))}
                         </TextField>
                     </Grid>
                     <Grid item xs={2}>
                         <TextField
                         key="qualifica"
                         label="Qualifica"
                         margin="normal"
                         value={qualifica}
                         fullWidth
                         InputLabelProps={{
                             shrink: true,
                         }}
                         variant="outlined"
                         onInput={ e => setQualifica(e.target.value)}
                         />
                     </Grid>
                     <Grid item xs={5}>
                         <TextField
                         key="sede"
                         label="Sede"
                         margin="normal"
                         value={sede}
                         fullWidth
                         InputLabelProps={{
                             shrink: true,
                         }}
                         variant="outlined"
                         onInput={ e => setSede(e.target.value)}
                         />
                     </Grid>
                     <Grid item xs={2}>
                         <TextField
                         key="cmd"
                         label="Numero CMD"
                         margin="normal"
                         value={numeroCmd}
                         fullWidth
                         InputLabelProps={{
                             shrink: true,
                         }}
                         variant="outlined"
                         onInput={ e => setNumeroCmd(e.target.value)}
                         />
                     </Grid>
                 </Grid>
            ) : null}
             {selectedStatus === "militareinservizio" ? (
                <Grid container item xs={12} spacing={2}>
                    
                    <Grid item xs={4}>
                         <TextField
                         key="grado"
                         label="Grado"
                         margin="normal"
                         value={grado}
                         fullWidth
                         InputLabelProps={{
                             shrink: true,
                         }}
                         variant="outlined"
                         onInput={ e => setGrado(e.target.value)}
                         />
                     </Grid>
                     <Grid item xs={2}>
                         <TextField
                         key="cmd"
                         label="Numero CMD"
                         margin="normal"
                         value={numeroCmd}
                         fullWidth
                         InputLabelProps={{
                             shrink: true,
                         }}
                         variant="outlined"
                         onInput={ e => setNumeroCmd(e.target.value)}
                         />
                     </Grid>
                 </Grid>
            ) : null}
             {selectedStatus === "dipcivileinservizio" ? (
                <Grid container item xs={12} spacing={2}>
                    
                     <Grid item xs={4}>
                         <TextField
                         key="qualifica"
                         label="Qualifica"
                         margin="normal"
                         value={qualifica}
                         fullWidth
                         InputLabelProps={{
                             shrink: true,
                         }}
                         variant="outlined"
                         onInput={ e => setQualifica(e.target.value)}
                         />
                     </Grid>
                     <Grid item xs={2}>
                         <TextField
                         key="cmd"
                         label="Numero CMD"
                         margin="normal"
                         value={numeroCmd}
                         fullWidth
                         InputLabelProps={{
                             shrink: true,
                         }}
                         variant="outlined"
                         onInput={ e => setNumeroCmd(e.target.value)}
                         />
                     </Grid>
                     
                 </Grid>
            ) : null}
             {selectedStatus === "militareinservizioAEAM" ? (
                <Grid container item xs={12} spacing={2}>
                     <Grid item xs={3}>
                         <TextField
                         key="grado"
                         label="Grado"
                         margin="normal"
                         value={grado}
                         fullWidth
                         InputLabelProps={{
                             shrink: true,
                         }}
                         variant="outlined"
                         onInput={ e => setGrado(e.target.value)}
                         />
                     </Grid>
                     <Grid item xs={6}>
                         <TextField
                         key="sede"
                         label="Sede"
                         value={sede}
                         margin="normal"
                         fullWidth
                         InputLabelProps={{
                             shrink: true,
                         }}
                         variant="outlined"
                         onInput={ e => setSede(e.target.value)}
                         />
                     </Grid>
                     <Grid item xs={2}>
                         <TextField
                         key="cmd"
                         label="Numero CMD"
                         margin="normal"
                         value={numeroCmd}
                         fullWidth
                         InputLabelProps={{
                             shrink: true,
                         }}
                         variant="outlined"
                         onInput={ e => setNumeroCmd(e.target.value)}
                         />
                     </Grid>
                 </Grid>
            ) : null}
             {selectedStatus === "dipcivileinservizioAEAM" ? (
                <Grid container item xs={12} spacing={2}>
                     <Grid item xs={3}>
                         <TextField
                         key="qualifica"
                         label="Qualifica"
                         margin="normal"
                         value={qualifica}
                         fullWidth
                         InputLabelProps={{
                             shrink: true,
                         }}
                         variant="outlined"
                         onInput={ e => setQualifica(e.target.value)}
                         />
                     </Grid>
                     <Grid item xs={6}>
                         <TextField
                         key="sede"
                         label="Sede"
                         value={sede}
                         margin="normal"
                         fullWidth
                         InputLabelProps={{
                             shrink: true,
                         }}
                         variant="outlined"
                         onInput={ e => setSede(e.target.value)}
                         />
                     </Grid>
                     <Grid item xs={2}>
                         <TextField
                         key="cmd"
                         label="Numero CMD"
                         margin="normal"
                         value={numeroCmd}
                         fullWidth
                         InputLabelProps={{
                             shrink: true,
                         }}
                         variant="outlined"
                         onInput={ e => setNumeroCmd(e.target.value)}
                         />
                     </Grid>
                 </Grid>
            ) : null}
             {selectedStatus === "coniugesuperstitepersonaleam" ? (
                <Grid container item xs={12} spacing={2}>
                     <Grid item xs={3}>
                         <TextField
                         key="nomeconiugedefunto"
                         label="Nome del coniuge defunto"
                         margin="normal"
                         value={nomeConiugeDefunto}
                         fullWidth
                         InputLabelProps={{
                             shrink: true,
                         }}
                         variant="outlined"
                         onInput={ e => setNomeConiugeDefunto(e.target.value)}
                         />
                     </Grid>
                     <Grid item xs={3}>
                         <TextField
                         key="cognomeconiugedefunto"
                         label="Cognome del coniuge defunto"
                         margin="normal"
                         value={cognomeConiugeDefunto}
                         fullWidth
                         InputLabelProps={{
                             shrink: true,
                         }}
                         variant="outlined"
                         onInput={ e => setCognomeConiugeDefunto(e.target.value)}
                         />
                     </Grid>
                     <Grid item xs={3}>
                         <TextField
                         key="tipoDocumento"
                         label="Tipo Documento (Titolare)"
                         margin="normal"
                         value={tipoDocumento}
                         fullWidth
                         InputLabelProps={{
                             shrink: true,
                         }}
                         variant="outlined"
                         onInput={ e => setTipoDocumento(e.target.value)}
                         />
                     </Grid>
                     <Grid item xs={3}>
                         <TextField
                         key="numeroDocumento"
                         label="Numero Documento (Titolare)"
                         margin="normal"
                         value={numeroDocumento}
                         fullWidth
                         InputLabelProps={{
                             shrink: true,
                         }}
                         variant="outlined"
                         onInput={ e => setNumeroDocumento(e.target.value)}
                         />
                     </Grid>
                     
                 </Grid>
            ) : null}
            {selectedStatus === "militareincongedoAA" ? (
                <Grid container item xs={12} spacing={2}>
                    
                    <Grid item xs={3}>
                         <TextField
                         key="grado"
                         label="Grado"
                         margin="normal"
                         value={grado}
                         fullWidth
                         InputLabelProps={{
                             shrink: true,
                         }}
                         variant="outlined"
                         onInput={ e => setGrado(e.target.value)}
                         />
                     </Grid>
                     <Grid item xs={3}>
                         <TextField
                         key="dataCongedo"
                         label="In congedo dal"
                         type="date"
                         value={dataCongedo}
                         margin="normal"
                         fullWidth
                         InputLabelProps={{
                             shrink: true,
                         }}
                         className={classes.textField}
                         variant="outlined"
                         onInput={ e => setDataCongedo(e.target.value)}
                         />
                     </Grid>
                     <Grid item xs={3}>
                         <TextField
                         key="tipoDocumento"
                         label="Tipo Documento"
                         margin="normal"
                         value={tipoDocumento}
                         fullWidth
                         InputLabelProps={{
                             shrink: true,
                         }}
                         variant="outlined"
                         onInput={ e => setTipoDocumento(e.target.value)}
                         />
                     </Grid>
                     <Grid item xs={3}>
                         <TextField
                         key="numeroDocumento"
                         label="Numero Documento"
                         margin="normal"
                         value={numeroDocumento}
                         fullWidth
                         InputLabelProps={{
                             shrink: true,
                         }}
                         variant="outlined"
                         onInput={ e => setNumeroDocumento(e.target.value)}
                         />
                     </Grid>
                     
                 </Grid>
            ) : null}
             {selectedStatus === "dipcivileinquiescenzaAA" ? (
                <Grid container item xs={12} spacing={2}>
                    
                     <Grid item xs={3}>
                         <TextField
                         key="qualifica"
                         label="Qualifica"
                         value={qualifica}
                         margin="normal"
                         fullWidth
                         InputLabelProps={{
                             shrink: true,
                         }}
                         variant="outlined"
                         onInput={ e => setQualifica(e.target.value)}
                         />
                     </Grid>

                     <Grid item xs={3}>
                         <TextField
                         key="dataCongedo"
                         label="In pensione dal"
                         value={dataCongedo}
                         type="date"
                         margin="normal"
                         fullWidth
                         InputLabelProps={{
                             shrink: true,
                         }}
                         className={classes.textField}
                         variant="outlined"
                         onInput={ e => setDataCongedo(e.target.value)}
                         />
                     </Grid>
                     <Grid item xs={3}>
                         <TextField
                         key="tipoDocumento"
                         label="Tipo Documento"
                         margin="normal"
                         value={tipoDocumento}
                         fullWidth
                         InputLabelProps={{
                             shrink: true,
                         }}
                         variant="outlined"
                         onInput={ e => setTipoDocumento(e.target.value)}
                         />
                     </Grid>
                     <Grid item xs={3}>
                         <TextField
                         key="numeroDocumento"
                         label="Numero Documento"
                         margin="normal"
                         value={numeroDocumento}
                         fullWidth
                         InputLabelProps={{
                             shrink: true,
                         }}
                         variant="outlined"
                         onInput={ e => setNumeroDocumento(e.target.value)}
                         />
                     </Grid>
                     
                 </Grid>
            ) : null}
            {selectedStatus === "militareincongedoMD" ? (
                <Grid container item xs={12} spacing={2}>
                    <Grid item xs={2}>
                         <TextField
                             key="forzaArmata"
                             name="forzaArmata"
                             select
                             label="Forza Armata"
                             fullWidth
                             margin="normal"
                             value={selectedFFAA}
                             onChange={handleChange}
                             InputLabelProps={{
                             shrink: true,
                             }}
                             variant="outlined"
                         >
                             {selectFFAA.map((option) => (
                             <MenuItem key={option.value} value={option.value}>
                                 {option.label}
                             </MenuItem>
                             ))}
                         </TextField>
                     </Grid>
                    <Grid item xs={2}>
                         <TextField
                         key="grado"
                         label="Grado"
                         margin="normal"
                         value={grado}
                         fullWidth
                         InputLabelProps={{
                             shrink: true,
                         }}
                         variant="outlined"
                         onInput={ e => setGrado(e.target.value)}
                         />
                     </Grid>
                     <Grid item xs={6}>
                         <TextField
                         key="sede"
                         label="Ultima sede"
                         value={sede}
                         margin="normal"
                         fullWidth
                         InputLabelProps={{
                             shrink: true,
                         }}
                         variant="outlined"
                         onInput={ e => setSede(e.target.value)}
                         />
                     </Grid>
                     <Grid item xs={2}>
                         <TextField
                         key="dataCongedo"
                         label="In congedo dal"
                         value={dataCongedo}
                         type="date"
                         margin="normal"
                         fullWidth
                         InputLabelProps={{
                             shrink: true,
                         }}
                         className={classes.textField}
                         variant="outlined"
                         onInput={ e => setDataCongedo(e.target.value)}
                         />
                     </Grid>
                     <Grid item xs={3}>
                         <TextField
                         key="tipoDocumento"
                         label="Tipo Documento"
                         margin="normal"
                         value={tipoDocumento}
                         fullWidth
                         InputLabelProps={{
                             shrink: true,
                         }}
                         variant="outlined"
                         onInput={ e => setTipoDocumento(e.target.value)}
                         />
                     </Grid>
                     <Grid item xs={3}>
                         <TextField
                         key="numeroDocumento"
                         label="Numero Documento"
                         margin="normal"
                         value={numeroDocumento}
                         fullWidth
                         InputLabelProps={{
                             shrink: true,
                         }}
                         variant="outlined"
                         onInput={ e => setNumeroDocumento(e.target.value)}
                         />
                     </Grid>
                     
                 </Grid>
            ) : null}
             {selectedStatus === "dipcivileinquiescenzaMD" ? (
                <Grid container item xs={12} spacing={2}>
                    <Grid item xs={2}>
                         <TextField
                             key="forzaArmata"
                             name="forzaArmata"
                             select
                             label="Forza Armata"
                             fullWidth
                             margin="normal"
                             value={selectedFFAA}
                             onChange={handleChange}
                             InputLabelProps={{
                             shrink: true,
                             }}
                             variant="outlined"
                         >
                             {selectFFAA.map((option) => (
                             <MenuItem key={option.value} value={option.value}>
                                 {option.label}
                             </MenuItem>
                             ))}
                         </TextField>
                     </Grid>
                     <Grid item xs={2}>
                         <TextField
                         key="qualifica"
                         label="Qualifica"
                         value={qualifica}
                         margin="normal"
                         fullWidth
                         InputLabelProps={{
                             shrink: true,
                         }}
                         variant="outlined"
                         onInput={ e => setQualifica(e.target.value)}
                         />
                     </Grid>
                     <Grid item xs={6}>
                         <TextField
                         key="sede"
                         label="Ultima sede"
                         value={sede}
                         margin="normal"
                         fullWidth
                         InputLabelProps={{
                             shrink: true,
                         }}
                         variant="outlined"
                         onInput={ e => setSede(e.target.value)}
                         />
                     </Grid>
                     <Grid item xs={2}>
                         <TextField
                         key="dataCongedo"
                         label="In pensione dal"
                         type="date"
                         value={dataCongedo}
                         margin="normal"
                         fullWidth
                         InputLabelProps={{
                             shrink: true,
                         }}
                         className={classes.textField}
                         variant="outlined"
                         onInput={ e => setDataCongedo(e.target.value)}
                         />
                     </Grid>
                     <Grid item xs={3}>
                         <TextField
                         key="tipoDocumento"
                         label="Tipo Documento"
                         margin="normal"
                         value={tipoDocumento}
                         fullWidth
                         InputLabelProps={{
                             shrink: true,
                         }}
                         variant="outlined"
                         onInput={ e => setTipoDocumento(e.target.value)}
                         />
                     </Grid>
                     <Grid item xs={3}>
                         <TextField
                         key="numeroDocumento"
                         label="Numero Documento"
                         margin="normal"
                         value={numeroDocumento}
                         fullWidth
                         InputLabelProps={{
                             shrink: true,
                         }}
                         variant="outlined"
                         onInput={ e => setNumeroDocumento(e.target.value)}
                         />
                     </Grid>
                     
                 </Grid>
            ) : null}
            {selectedStatus === "coniugesuperstitealtropersonale" ? (
                <Grid container item xs={12} spacing={2}>
                     <Grid item xs={4}>
                         <TextField
                             key="forzaArmataAll"
                             name="forzaArmataAll"
                             select
                             label="F.A. Coniuge Defunto"
                             fullWidth
                             margin="normal"
                             value={selectedAllFFAA}
                             onChange={handleChange}
                             InputLabelProps={{
                             shrink: true,
                             }}
                             variant="outlined"
                         >
                             {selectAllFFAA.map((option) => (
                             <MenuItem key={option.value} value={option.value}>
                                 {option.label}
                             </MenuItem>
                             ))}
                         </TextField>
                     </Grid>
                     <Grid item xs={4}>
                         <TextField
                         key="nomeconiugedefunto"
                         label="Nome del coniuge defunto"
                         value={nomeConiugeDefunto}
                         margin="normal"
                         fullWidth
                         InputLabelProps={{
                             shrink: true,
                         }}
                         variant="outlined"
                         onInput={ e => setNomeConiugeDefunto(e.target.value)}
                         />
                     </Grid>
                     <Grid item xs={4}>
                         <TextField
                         key="cognomeconiugedefunto"
                         label="Cognome del coniuge defunto"
                         value={cognomeConiugeDefunto}
                         margin="normal"
                         fullWidth
                         InputLabelProps={{
                             shrink: true,
                         }}
                         variant="outlined"
                         onInput={ e => setCognomeConiugeDefunto(e.target.value)}
                         />
                     </Grid>
                     <Grid item xs={3}>
                         <TextField
                         key="tipoDocumento"
                         label="Tipo Documento (Titolare)"
                         margin="normal"
                         value={tipoDocumento}
                         fullWidth
                         InputLabelProps={{
                             shrink: true,
                         }}
                         variant="outlined"
                         onInput={ e => setTipoDocumento(e.target.value)}
                         />
                     </Grid>
                     <Grid item xs={3}>
                         <TextField
                         key="numeroDocumento"
                         label="Numero Documento (Titolare)"
                         margin="normal"
                         value={numeroDocumento}
                         fullWidth
                         InputLabelProps={{
                             shrink: true,
                         }}
                         variant="outlined"
                         onInput={ e => setNumeroDocumento(e.target.value)}
                         />
                     </Grid>
                 </Grid>
                 
            ) : null}
             {selectedStatus === "personaleDitteAA" ? (
                <Grid container item xs={12} spacing={2}>
                    
                    <Grid item xs={6}>
                         <TextField
                         key="sede"
                         label="Ditta/Azienda"
                         value={sede}
                         margin="normal"
                         fullWidth
                         InputLabelProps={{
                             shrink: true,
                         }}
                         variant="outlined"
                         onInput={ e => setSede(e.target.value)}
                         />
                     </Grid>
                     <Grid item xs={3}>
                         <TextField
                         key="tipoDocumento"
                         label="Tipo Documento"
                         margin="normal"
                         value={tipoDocumento}
                         fullWidth
                         InputLabelProps={{
                             shrink: true,
                         }}
                         variant="outlined"
                         onInput={ e => setTipoDocumento(e.target.value)}
                         />
                     </Grid>
                     <Grid item xs={3}>
                         <TextField
                         key="numeroDocumento"
                         label="Numero Documento"
                         margin="normal"
                         value={numeroDocumento}
                         fullWidth
                         InputLabelProps={{
                             shrink: true,
                         }}
                         variant="outlined"
                         onInput={ e => setNumeroDocumento(e.target.value)}
                         />
                     </Grid>
                 </Grid>
                 
            ) : null}
             {selectedStatus === "autorita" ? (
                <Grid container item xs={12} spacing={2}>
                    
                    <Grid item xs={6}>
                         <TextField
                         key="sede"
                         label="Titolo di benemerenza"
                         value={sede}
                         margin="normal"
                         fullWidth
                         InputLabelProps={{
                             shrink: true,
                         }}
                         variant="outlined"
                         onInput={ e => setSede(e.target.value)}
                         />
                     </Grid>
                     <Grid item xs={3}>
                         <TextField
                         key="tipoDocumento"
                         label="Tipo Documento"
                         margin="normal"
                         value={tipoDocumento}
                         fullWidth
                         InputLabelProps={{
                             shrink: true,
                         }}
                         variant="outlined"
                         onInput={ e => setTipoDocumento(e.target.value)}
                         />
                     </Grid>
                     <Grid item xs={3}>
                         <TextField
                         key="numeroDocumento"
                         label="Numero Documento"
                         margin="normal"
                         value={numeroDocumento}
                         fullWidth
                         InputLabelProps={{
                             shrink: true,
                         }}
                         variant="outlined"
                         onInput={ e => setNumeroDocumento(e.target.value)}
                         />
                     </Grid>
                 </Grid>
                 
            ) : null}
          </Grid>           
        );
        case 2:
        return (
            <Grid container item xs={12} alignItems="center">
                 <Grid item xs={12}> 
                    <Typography  variant="h6" component="h6" >
                        {"SCELTA TURNI"}
                    </Typography>
                </Grid>
                 {selectedStatus === "militareinservizio" || selectedStatus === "dipcivileinservizio" ? (
                        <Grid item xs={12} >
                            <TextField
                                    key="turno_AA"
                                    name="turno_AA"
                                    select
                                    label="Chiedo l'ammissione"
                                    fullWidth
                                    margin="normal"
                                    value={selectedTurnoAA}
                                    onChange={handleChange}
                                    InputLabelProps={{
                                    shrink: true,
                                    }}
                                    variant="outlined"
                                >
                                    {selectTurniAA.map((option) => (
                                    <MenuItem key={option.value} value={option.value}>
                                        {option.label}
                                    </MenuItem>
                                    ))}
                                </TextField>
                        </Grid>
                ) : null}
                 {selectedStatus !== "militareinservizio" && selectedStatus !== "dipcivileinservizio" ? (
                        <Grid container item xs={12} spacing={2}>
                             <Grid container item xs={12} spacing={2}>
                                    <Grid item xs={8} >
                                        <TextField
                                            key="1_turno_Altro"
                                            name="1_turno_Altro"
                                            select
                                            label="Chiedo l'ammissione al 1° Turno (dal 1 Luglio al 31 Luglio)"
                                            fullWidth
                                            margin="normal"
                                            value={selectedTurno1Altro}
                                            onChange={handleChange}
                                            InputLabelProps={{
                                            shrink: true,
                                            }}
                                            variant="outlined"
                                        >
                                            {selectTurniAEAM.map((option) => (
                                            <MenuItem key={option.value} value={option.value}>
                                                {option.label}
                                            </MenuItem>
                                            ))}
                                        </TextField>
                                    </Grid>
                                    {selectedTurno1Altro === "yes" ? (
                                        <Grid item xs={4} >
                                        <TextField
                                            key="1_turno_Altro_pr"
                                            name="1_turno_Altro_pr"
                                            select
                                            label="Con priorità"
                                            fullWidth
                                            margin="normal"
                                            value={selectedTurno1Altropr}
                                            onChange={handleChange}
                                            InputLabelProps={{
                                            shrink: true,
                                            }}
                                            variant="outlined"
                                        >
                                            {selectTurniAEAMpr.map((option) => (
                                            <MenuItem key={option.value} value={option.value}>
                                                {option.label}
                                            </MenuItem>
                                            ))}
                                        </TextField>
                                    </Grid>
                                ) : null}
                            </Grid>
                            <Grid container item xs={12} spacing={2}>
                            <Grid item xs={8} >
                                <TextField
                                    key="2_turno_Altro"
                                    name="2_turno_Altro"
                                    select
                                    label="Chiedo l'ammissione al 2° Turno (dal 1 Agosto al 31 Agosto)"
                                    fullWidth
                                    margin="normal"
                                    value={selectedTurno2Altro}
                                    onChange={handleChange}
                                    InputLabelProps={{
                                    shrink: true,
                                    }}
                                    variant="outlined"
                                >
                                    {selectTurniAEAM.map((option) => (
                                    <MenuItem key={option.value} value={option.value}>
                                        {option.label}
                                    </MenuItem>
                                    ))}
                                </TextField>
                            </Grid>
                                {selectedTurno2Altro === "yes" ? (
                                    <Grid item xs={4} >
                                    <TextField
                                        key="2_turno_Altro_pr"
                                        name="2_turno_Altro_pr"
                                        select
                                        label="Con priorità"
                                        fullWidth
                                        margin="normal"
                                        value={selectedTurno2Altropr}
                                        onChange={handleChange}
                                        InputLabelProps={{
                                        shrink: true,
                                        }}
                                        variant="outlined"
                                    >
                                        {selectTurniAEAMpr.map((option) => (
                                        <MenuItem key={option.value} value={option.value}>
                                            {option.label}
                                        </MenuItem>
                                        ))}
                                    </TextField>
                                </Grid>
                            ) : null}
                            </Grid>
                        </Grid>
                        
                ) : null}
                <Grid item xs={8} >
                            <TextField
                                    key="cabina"
                                    name="cabina"
                                    select
                                    label="Chiedo di poter usufruire del servizio cabina (per nuclei con figli minori di 12 anni)"
                                    fullWidth
                                    margin="normal"
                                    value={selectedCabina}
                                    onChange={handleChange}
                                    InputLabelProps={{
                                    shrink: true,
                                    }}
                                    variant="outlined"
                                >
                                     {selectTurniAEAM.map((option) => (
                                        <MenuItem key={option.value} value={option.value}>
                                            {option.label}
                                        </MenuItem>
                                        ))}
                                </TextField>
                        </Grid>
                
            </Grid>
        );
        case 3:
        return (
            <Grid container item xs={12} alignItems="center">
                <Grid item xs={12}> 
                    <Typography  variant="h6" component="h6" >
                        {"ANAGRAFICA FAMILIARI"}
                    </Typography>
                    <Typography component="div">
                        <Box textAlign="justify" m={1}>
                        Oltre al Titolare possono essere assegnatari di abbonamento anche i componenti del nucleo familiare dello stesso.</Box>
                        <Box textAlign="justify" m={1}>
                        Per nucleo familiare si intendono moglie, marito e figli. Per gli altri componenti (suoceri, genitori, figli sposati, etc) è necessario presentare la certificazione anagrafica rilasciata dal Comune di residenza che ne attesti l'effettiva convivenza.</Box>
                        <Box textAlign="justify" m={1}>
                        Solo al personale in servizio presso l'Accademia Aeronautica è concesso di presentare richiesta di abbonamento
                        anche per i figli non sposati e/o genitori/suoceri  non compresi nello stato di famiglia.</Box>
                    </Typography>
                </Grid>
                <Grid item xs={6}>
                <TextField
                    key="numeroabbonamenti"
                    name="numeroabbonamenti"
                    select
                    label="Numero abbonamenti richiesti oltre quello del titolare"
                    fullWidth
                    margin="normal"
                    value={selectedNAbbonamenti}
                    onChange={handleChange}
                    InputLabelProps={{
                    shrink: true,
                    }}
                    variant="outlined"
                >
                    {selectNAbbonamenti.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                        {option.label}
                    </MenuItem>
                    ))}
                </TextField>
            </Grid>
            {selectedNAbbonamenti > 0 ? (
                <Grid container item xs={12} alignItems="center" spacing={2}>
                    <Grid item xs={2} >
                            <TextField
                                    key="grado_parentela_1"
                                    name="grado_parentela_1"
                                    select
                                    label="Grado di parentela"
                                    fullWidth
                                    margin="normal"
                                    value={selectedGP1}
                                    onChange={handleChange}
                                    InputLabelProps={{
                                    shrink: true,
                                    }}
                                    variant="outlined"
                                >
                                    {selectGP.map((option) => (
                                    <MenuItem key={option.value} value={option.value}>
                                        {option.label}
                                    </MenuItem>
                                    ))}
                                </TextField>
                        </Grid>
                         <Grid item xs={3}>
                            <TextField
                            key="nomep1"
                            value={nomep1}
                            label="Nome"
                            margin="normal"
                            fullWidth
                            InputLabelProps={{
                                shrink: true,
                            }}
                            variant="outlined"
                            onInput={ e => setNomeP1(e.target.value)}
                            />
                      </Grid>
                      <Grid item xs={3}>
                            <TextField
                            key="cognomep1"
                            value={cognomep1}
                            label="Cognome"
                            margin="normal"
                            fullWidth
                            InputLabelProps={{
                                shrink: true,
                            }}
                            variant="outlined"
                            onInput={ e => setCognomeP1(e.target.value)}
                            />
                      </Grid>
                      <Grid item xs={2}>
                         <TextField
                         key="datanascitap1"
                         label="Data di nascita"
                         value={datanascitap1}
                         type="date"
                         margin="normal"
                         fullWidth
                         InputLabelProps={{
                             shrink: true,
                         }}
                         className={classes.textField}
                         variant="outlined"
                         onInput={ e => setDataNascitaP1(e.target.value)}
                         />
                     </Grid>
                     <Grid item xs={2}>
                         <TextField
                         key="notep1"
                         label="Note turni"
                         value={notep1}
                         margin="normal"
                         fullWidth
                         InputLabelProps={{
                             shrink: true,
                         }}
                         className={classes.textField}
                         variant="outlined"
                         onInput={ e => setNoteP1(e.target.value)}
                         />
                     </Grid>
                    </Grid>
                        
                ) : null}
            {selectedNAbbonamenti > 1 ? (
                <Grid container item xs={12} alignItems="center" spacing={2}>
                    <Grid item xs={2} >
                            <TextField
                                    key="grado_parentela_2"
                                    name="grado_parentela_2"
                                    select
                                    label="Grado di parentela"
                                    fullWidth
                                    margin="normal"
                                    value={selectedGP2}
                                    onChange={handleChange}
                                    InputLabelProps={{
                                    shrink: true,
                                    }}
                                    variant="outlined"
                                >
                                    {selectGP.map((option) => (
                                    <MenuItem key={option.value} value={option.value}>
                                        {option.label}
                                    </MenuItem>
                                    ))}
                                </TextField>
                        </Grid>
                         <Grid item xs={3}>
                            <TextField
                            key="nomep2"
                            value={nomep2}
                            label="Nome"
                            margin="normal"
                            fullWidth
                            InputLabelProps={{
                                shrink: true,
                            }}
                            variant="outlined"
                            onInput={ e => setNomeP2(e.target.value)}
                            />
                      </Grid>
                      <Grid item xs={3}>
                            <TextField
                            key="cognomep2"
                            label="Cognome"
                            value={cognomep2}
                            margin="normal"
                            fullWidth
                            InputLabelProps={{
                                shrink: true,
                            }}
                            variant="outlined"
                            onInput={ e => setCognomeP2(e.target.value)}
                            />
                      </Grid>
                      <Grid item xs={2}>
                         <TextField
                         key="datanascitap2"
                         label="Data di nascita"
                         value={datanascitap2}
                         type="date"
                         margin="normal"
                         fullWidth
                         InputLabelProps={{
                             shrink: true,
                         }}
                         className={classes.textField}
                         variant="outlined"
                         onInput={ e => setDataNascitaP2(e.target.value)}
                         />
                     </Grid>
                     <Grid item xs={2}>
                         <TextField
                         key="notep2"
                         label="Note turni"
                         value={notep2}
                         margin="normal"
                         fullWidth
                         InputLabelProps={{
                             shrink: true,
                         }}
                         className={classes.textField}
                         variant="outlined"
                         onInput={ e => setNoteP2(e.target.value)}
                         />
                     </Grid>
                    </Grid>
                        
                ) : null}
            {selectedNAbbonamenti > 2 ? (
                <Grid container item xs={12} alignItems="center" spacing={2}>
                    <Grid item xs={2} >
                            <TextField
                                    key="grado_parentela_3"
                                    name="grado_parentela_3"
                                    select
                                    label="Grado di parentela"
                                    fullWidth
                                    margin="normal"
                                    value={selectedGP3}
                                    onChange={handleChange}
                                    InputLabelProps={{
                                    shrink: true,
                                    }}
                                    variant="outlined"
                                >
                                    {selectGP.map((option) => (
                                    <MenuItem key={option.value} value={option.value}>
                                        {option.label}
                                    </MenuItem>
                                    ))}
                                </TextField>
                        </Grid>
                         <Grid item xs={3}>
                            <TextField
                            key="nomep3"
                            value={nomep3}
                            label="Nome"
                            margin="normal"
                            fullWidth
                            InputLabelProps={{
                                shrink: true,
                            }}
                            variant="outlined"
                            onInput={ e => setNomeP3(e.target.value)}
                            />
                      </Grid>
                      <Grid item xs={3}>
                            <TextField
                            key="cognomep3"
                            value={cognomep3}
                            label="Cognome"
                            margin="normal"
                            fullWidth
                            InputLabelProps={{
                                shrink: true,
                            }}
                            variant="outlined"
                            onInput={ e => setCognomeP3(e.target.value)}
                            />
                      </Grid>
                      <Grid item xs={2}>
                         <TextField
                         key="datanascitap3"
                         value={datanascitap3}
                         label="Data di nascita"
                         type="date"
                         margin="normal"
                         fullWidth
                         InputLabelProps={{
                             shrink: true,
                         }}
                         className={classes.textField}
                         variant="outlined"
                         onInput={ e => setDataNascitaP3(e.target.value)}
                         />
                     </Grid>
                     <Grid item xs={2}>
                         <TextField
                         key="notep3"
                         label="Note turni"
                         value={notep3}
                         margin="normal"
                         fullWidth
                         InputLabelProps={{
                             shrink: true,
                         }}
                         className={classes.textField}
                         variant="outlined"
                         onInput={ e => setNoteP3(e.target.value)}
                         />
                     </Grid>
                    </Grid>
                        
                ) : null}
            {selectedNAbbonamenti > 3 ? (
                <Grid container item xs={12} alignItems="center" spacing={2}>
                    <Grid item xs={2} >
                            <TextField
                                    key="grado_parentela_4"
                                    name="grado_parentela_4"
                                    select
                                    label="Grado di parentela"
                                    fullWidth
                                    margin="normal"
                                    value={selectedGP4}
                                    onChange={handleChange}
                                    InputLabelProps={{
                                    shrink: true,
                                    }}
                                    variant="outlined"
                                >
                                    {selectGP.map((option) => (
                                    <MenuItem key={option.value} value={option.value}>
                                        {option.label}
                                    </MenuItem>
                                    ))}
                                </TextField>
                        </Grid>
                         <Grid item xs={3}>
                            <TextField
                            key="nomep4"
                            value={nomep4}
                            label="Nome"
                            margin="normal"
                            fullWidth
                            InputLabelProps={{
                                shrink: true,
                            }}
                            variant="outlined"
                            onInput={ e => setNomeP4(e.target.value)}
                            />
                      </Grid>
                      <Grid item xs={3}>
                            <TextField
                            key="cognomep4"
                            value={cognomep4}
                            label="Cognome"
                            margin="normal"
                            fullWidth
                            InputLabelProps={{
                                shrink: true,
                            }}
                            variant="outlined"
                            onInput={ e => setCognomeP4(e.target.value)}
                            />
                      </Grid>
                      <Grid item xs={2}>
                         <TextField
                         key="datanascitap4"
                         value={datanascitap4}
                         label="Data di nascita"
                         type="date"
                         margin="normal"
                         fullWidth
                         InputLabelProps={{
                             shrink: true,
                         }}
                         className={classes.textField}
                         variant="outlined"
                         onInput={ e => setDataNascitaP4(e.target.value)}
                         />
                     </Grid>
                     <Grid item xs={2}>
                         <TextField
                         key="notep4"
                         label="Note turni"
                         value={notep4}
                         margin="normal"
                         fullWidth
                         InputLabelProps={{
                             shrink: true,
                         }}
                         className={classes.textField}
                         variant="outlined"
                         onInput={ e => setNoteP4(e.target.value)}
                         />
                     </Grid>
                    </Grid>
                        
                ) : null}
            {selectedNAbbonamenti > 4 ? (
                <Grid container item xs={12} alignItems="center" spacing={2}>
                    <Grid item xs={2} >
                            <TextField
                                    key="grado_parentela_5"
                                    name="grado_parentela_5"
                                    select
                                    label="Grado di parentela"
                                    fullWidth
                                    margin="normal"
                                    value={selectedGP5}
                                    onChange={handleChange}
                                    InputLabelProps={{
                                    shrink: true,
                                    }}
                                    variant="outlined"
                                >
                                    {selectGP.map((option) => (
                                    <MenuItem key={option.value} value={option.value}>
                                        {option.label}
                                    </MenuItem>
                                    ))}
                                </TextField>
                        </Grid>
                         <Grid item xs={3}>
                            <TextField
                            key="nomep5"
                            value={nomep5}
                            label="Nome"
                            margin="normal"
                            fullWidth
                            InputLabelProps={{
                                shrink: true,
                            }}
                            variant="outlined"
                            onInput={ e => setNomeP5(e.target.value)}
                            />
                      </Grid>
                      <Grid item xs={3}>
                            <TextField
                            key="cognomep5"
                            label="Cognome"
                            value={cognomep5}
                            margin="normal"
                            fullWidth
                            InputLabelProps={{
                                shrink: true,
                            }}
                            variant="outlined"
                            onInput={ e => setCognomeP5(e.target.value)}
                            />
                      </Grid>
                      <Grid item xs={2}>
                         <TextField
                         key="datanascitap5"
                         value={datanascitap5}
                         label="Data di nascita"
                         type="date"
                         margin="normal"
                         fullWidth
                         InputLabelProps={{
                             shrink: true,
                         }}
                         className={classes.textField}
                         variant="outlined"
                         onInput={ e => setDataNascitaP5(e.target.value)}
                         />
                     </Grid>
                     <Grid item xs={2}>
                         <TextField
                         key="notep5"
                         label="Note turni"
                         value={notep5}
                         margin="normal"
                         fullWidth
                         InputLabelProps={{
                             shrink: true,
                         }}
                         className={classes.textField}
                         variant="outlined"
                         onInput={ e => setNoteP5(e.target.value)}
                         />
                     </Grid>
                    </Grid>
                        
                ) : null}
            {selectedNAbbonamenti > 5 ? (
                <Grid container item xs={12} alignItems="center" spacing={2}>
                    <Grid item xs={2} >
                            <TextField
                                    key="grado_parentela_6"
                                    name="grado_parentela_6"
                                    select
                                    label="Grado di parentela"
                                    fullWidth
                                    margin="normal"
                                    value={selectedGP6}
                                    onChange={handleChange}
                                    InputLabelProps={{
                                    shrink: true,
                                    }}
                                    variant="outlined"
                                >
                                    {selectGP.map((option) => (
                                    <MenuItem key={option.value} value={option.value}>
                                        {option.label}
                                    </MenuItem>
                                    ))}
                                </TextField>
                        </Grid>
                         <Grid item xs={3}>
                            <TextField
                            key="nomep6"
                            value={nomep6}
                            label="Nome"
                            margin="normal"
                            fullWidth
                            InputLabelProps={{
                                shrink: true,
                            }}
                            variant="outlined"
                            onInput={ e => setNomeP6(e.target.value)}
                            />
                      </Grid>
                      <Grid item xs={3}>
                            <TextField
                            key="cognomep6"
                            value={cognomep6}
                            label="Cognome"
                            margin="normal"
                            fullWidth
                            InputLabelProps={{
                                shrink: true,
                            }}
                            variant="outlined"
                            onInput={ e => setCognomeP6(e.target.value)}
                            />
                      </Grid>
                      <Grid item xs={2}>
                         <TextField
                         key="datanascitap6"
                         value={datanascitap6}
                         label="Data di nascita"
                         type="date"
                         margin="normal"
                         fullWidth
                         InputLabelProps={{
                             shrink: true,
                         }}
                         className={classes.textField}
                         variant="outlined"
                         onInput={ e => setDataNascitaP6(e.target.value)}
                         />
                     </Grid>
                     <Grid item xs={2}>
                         <TextField
                         key="notep6"
                         label="Note turni"
                         value={notep6}
                         margin="normal"
                         fullWidth
                         InputLabelProps={{
                             shrink: true,
                         }}
                         className={classes.textField}
                         variant="outlined"
                         onInput={ e => setNoteP6(e.target.value)}
                         />
                     </Grid>
                    </Grid>
                        
                ) : null}
            </Grid>
        );
        case 4:
        return (
            <Grid container spacing={2}>
                <Grid item xs={12} md={12}>
                        <Card className={classes.root}>
                            <CardContent>
                                <Grid container item alignItems="center" spacing={1}>
                                    <Grid item>
                                        <Typography gutterBottom variant="h5" component="h2">
                                            RIEPILOGO DATI TITOLARE
                                        </Typography>
                                    </Grid>
                                </Grid>
                            <Divider />
                            <DataItem 
                                title="Il sottoscritto "
                                data={grado + " " + qualifica + " " + nome + " " + cognome}
                                first={true}
                            ></DataItem>
                            <DataItem
                                title="Residente in "
                                data={citta + " - " + via + ", " + civico + " - CAP " + cap}
                                first={true}
                            ></DataItem>
                            {selectedStatus === "militareinservizio" || selectedStatus === "dipcivileinservizio" ? (
                                <Grid>
                                    <DataItem
                                        title="In servizio presso "
                                        data={"l'Accademia Aeronautica di Pozzuoli o Ente Coubicato"}
                                        first={true}
                                    ></DataItem>
                                </Grid>
                            
                            ) : null}
                            {selectedStatus === "militareinservizioAEAM" || selectedStatus === "dipcivileinservizioAEAM" ? (
                                <Grid>
                                    <DataItem
                                        title="In servizio presso "
                                        data={sede}
                                        first={true}
                                    ></DataItem>
                                </Grid>
                                
                            ) : null}
                            {selectedStatus === "militareinservizioMD" || selectedStatus === "dipcivileinservizioMD" ? (
                                <Grid>
                                    <DataItem
                                        title="Forza Armata di appartenenza  "
                                        data={selectedFFAA}
                                        first={true}
                                    ></DataItem>
                                    <DataItem
                                        title="In servizio presso "
                                        data={sede}
                                        first={true}
                                    ></DataItem>
                                    
                                </Grid>
                            ) : null}
                            {selectedStatus === "militareincongedoAA" ? (
                                <Grid>
                                    <DataItem
                                        title="In congedo già in forza presso "
                                        data={"l'Accademia Aeronautica di Pozzuoli o Ente Coubicato"}
                                        first={true}
                                    ></DataItem> 
                                    <DataItem
                                        title="Data congedo"
                                        data={dataCongedo}
                                        first={true}
                                    ></DataItem>        
                                </Grid>
                            ) : null}
                            {selectedStatus === "dipcivileinquiescenzaAA" ? (
                                <Grid>
                                    <DataItem
                                        title="In quiescenza già in forza presso "
                                        data={"l'Accademia Aeronautica di Pozzuoli o Ente Coubicato"}
                                        first={true}
                                    ></DataItem> 
                                    <DataItem
                                        title="Data quiescenza"
                                        data={dataCongedo}
                                        first={true}
                                    ></DataItem>        
                                </Grid>
                            ) : null}
                            {selectedStatus === "militareincongedoMD" ? (
                                <Grid>
                                    <DataItem
                                        title="Forza Armata di appartenenza  "
                                        data={selectedFFAA}
                                        first={true}
                                    ></DataItem>
                                    <DataItem
                                        title="In congedo già in forza presso "
                                        data={sede}
                                        first={true}
                                    ></DataItem> 
                                    <DataItem
                                        title="Data congedo "
                                        data={dataCongedo}
                                        first={true}
                                    ></DataItem>        
                                </Grid>
                            ) : null}
                            {selectedStatus === "dipcivileinquiescenzaMD" ? (
                                <Grid>
                                    <DataItem
                                        title="Forza Armata di appartenenza  "
                                        data={selectedFFAA}
                                        first={true}
                                    ></DataItem>
                                    <DataItem
                                        title="In quiescenza già in forza presso "
                                        data={sede}
                                        first={true}
                                    ></DataItem> 
                                    <DataItem
                                        title="Data quiescenza "
                                        data={dataCongedo}
                                        first={true}
                                    ></DataItem>        
                                </Grid>
                            ) : null}
                            {selectedStatus === "coniugesuperstitepersonaleam" ? (
                                <Grid>
                                    <DataItem
                                        title="Coniuge superstite del personale (in servizio) militare o civile "
                                        data={"dell'Aeronautica Militare"}
                                        first={true}
                                    ></DataItem>
                                    <DataItem
                                        title="Coniuge defunto "
                                        data={nomeConiugeDefunto + " " + cognomeConiugeDefunto}
                                        first={true}
                                    ></DataItem>       
                                </Grid>
                            ) : null}
                            {selectedStatus === "coniugesuperstitealtropersonale" ? (
                                <Grid>
                                    <DataItem
                                        title="Coniuge superstite del personale (congedo o quiescenza) militare o civile della Forza Armata "
                                        data={selectedAllFFAA}
                                        first={true}
                                    ></DataItem>
                                    <DataItem
                                        title="Coniuge defunto "
                                        data={nomeConiugeDefunto + " " + cognomeConiugeDefunto}
                                        first={true}
                                    ></DataItem>       
                                </Grid>
                            ) : null}
                            </CardContent>
                        </Card>
                    </Grid>
            
                    <Grid item xs={12} md={12}>
                        <Card className={classes.root}>
                            <CardContent>
                                <Grid container item alignItems="center" spacing={1}>
                                    <Grid item>
                                        <Typography gutterBottom variant="h5" component="h2">
                                            CHIEDE
                                        </Typography>
                                    </Grid>
                                </Grid>
                            <Divider />
                            {selectedStatus === "militareinservizio" || selectedStatus === "dipcivileinservizio" ? (
                                <Grid>
                                    <DataItem 
                                        title="Per i turni "
                                        data={selectedTurnoAA}
                                        first={true}
                                    ></DataItem>     
                                </Grid>
                            ) : null}
                            {selectedStatus !== "militareinservizio" && selectedStatus !== "dipcivileinservizio" ? (
                                <Grid>
                                    <DataItem 
                                        title="Per i turni "
                                        data={(selectedTurno1Altro === "yes" && selectedTurno2Altro === "yes" ? "1° Turno (priorità "+ selectedTurno1Altropr +") e 2° Turno (priorità "+ selectedTurno2Altropr +")" : (selectedTurno1Altro === "yes" && selectedTurno2Altro === "no" ? "1° Turno" : (selectedTurno1Altro === "no" && selectedTurno2Altro === "yes" ? "2° Turno" : "")))}
                                        first={true}
                                    ></DataItem>     
                                </Grid>
                            ) : null}
                            <DataItem 
                                title="che gli siano concessi numero abbonamenti "
                                data={(selectedNAbbonamenti + 1)}
                                first={true}
                            ></DataItem>
                            <DataItem 
                                title="Così dettagliati "
                                data={" "}
                                first={true}
                            ></DataItem>
                            <DataItem 
                                title="   - Abbonamento per il "
                                data={"Titolare"}
                                first={true}
                            ></DataItem>
                            {selectedNAbbonamenti > 0 ? (
                                <Grid>
                                    <DataItem 
                                        title="   - Abbonamento per "
                                        data={ nomep1 + " " + cognomep1 + " "  + selectedGP1 + " del Titolare " + (notep1 !== "" ? "(Note turni: " + notep1 + ")" : "")}
                                        first={true}
                                    ></DataItem>
                                </Grid>
                                ) : null}
                             {selectedNAbbonamenti > 1 ? (
                                <Grid>
                                    <DataItem 
                                        title="   - Abbonamento per "
                                        data={ nomep2 + " " + cognomep2 + " "  + selectedGP2 + " del Titolare " + (notep2 !== "" ? "(Note turni: " + notep2 + ")" : "")}
                                        first={true}
                                    ></DataItem>
                                </Grid>
                                ) : null}
                             {selectedNAbbonamenti > 2 ? (
                                <Grid>
                                    <DataItem 
                                        title="   - Abbonamento per "
                                        data={ nomep3 + " " + cognomep3 + " "  + selectedGP3 + " del Titolare " + (notep3 !== "" ? "(Note turni: " + notep3 + ")" : "")}
                                        first={true}
                                    ></DataItem>
                                </Grid>
                                ) : null}
                              {selectedNAbbonamenti > 3 ? (
                                <Grid>
                                    <DataItem 
                                        title="   - Abbonamento per "
                                        data={ nomep4 + " " + cognomep4 + " "  + selectedGP4 + " del Titolare " + (notep4 !== "" ? "(Note turni: " + notep4 + ")" : "")}
                                        first={true}
                                    ></DataItem>
                                </Grid>
                                ) : null}
                              {selectedNAbbonamenti > 4 ? (
                                <Grid>
                                    <DataItem 
                                        title="   - Abbonamento per "
                                        data={ nomep5 + " " + cognomep5 + " "  + selectedGP5 + " del Titolare " + (notep5 !== "" ? "(Note turni: " + notep5 + ")" : "")}
                                        first={true}
                                    ></DataItem>
                                </Grid>
                                ) : null}
                              {selectedNAbbonamenti > 5 ? (
                                <Grid>
                                    <DataItem 
                                        title="   - Abbonamento per "
                                        data={ nomep6 + " " + cognomep6 + " "  + selectedGP6 + " del Titolare " + (notep6 !== "" ? "(Note turni: " + notep6 + ")" : "")}
                                        first={true}
                                    ></DataItem>
                                </Grid>
                                ) : null}
                                 <DataItem 
                                    title="Cabina "
                                    data={selectedCabina === "yes" ? "richiesta" : "non richiesta"}
                                    first={true}
                                ></DataItem>
                                 <DataItem 
                                    title=" "
                                    data={ " "}
                                    first={true}
                                ></DataItem>
                                <Divider />
                                {selectedNAbbonamenti > 1 ? (
                                <Grid>
                                    <DataItem 
                                        title=" "
                                        data={ " "}
                                        first={true}
                                    ></DataItem>
                                      {selectedStatus === "militareinservizio" || selectedStatus === "dipcivileinservizio" ? (
                                            <Typography component="div">
                                                <Box textAlign="justify" m={1}>
                                                </Box>
                                            </Typography>
                                        
                                        ) : 
                                        
                                        <Typography component="div">
                                            <Box textAlign="justify" m={1}>
                                                Il Titolare della presente dichiara sotto la propria responsabilità che le persone per le quali ha chiesto la concessione dell'abbonamento sono parte del proprio nucleo familiare.
                                                Il Titolare inoltre si impegna a presentare, ad integrazione della presente, la certificazione dello Stato di Famiglia rilasciata dal proprio comune di residenza.
                                            </Box>
                                        </Typography>
                                    }

                                   
                                 
                                </Grid>
                                ) : null}
                                 <DataItem 
                                        title=" "
                                        data={ " "}
                                        first={true}
                                    ></DataItem>
                                     <Typography component="div">
                                        <Box textAlign="justify" m={1}>
                                            Il Titolare, a completamento della richiesta, riceverà una mail alla casella di posta elettronica {email} che conterrà
                                             indicazioni su come intergrare documento di riconoscimento, foto tessere e Stato di famiglia se previsto.
                                        </Box>
                                    </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
        
            
            </Grid>
        );
        default:
        return "Errore";
    }
}

export default function RichiestaAbbonamento(props) {
  const history = useHistory();
  const classes = useStyles();

  const [activeStep, setActiveStep] = React.useState(0);
  const steps = getSteps();

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleSubmit = e =>{
    e.preventDefault();
    setSending(1);
    console.log("CREATE");
  

   
    let familiari =  [  { gradoParentela : selectedGP1, nome : nomep1, cognome : cognomep1, dataNascita: datanascitap1, noteTurni : notep1}, 
                        { gradoParentela : selectedGP2, nome : nomep2, cognome : cognomep2, dataNascita: datanascitap2, noteTurni : notep2},
                        { gradoParentela : selectedGP3, nome : nomep3, cognome : cognomep3, dataNascita: datanascitap3, noteTurni : notep3},
                        { gradoParentela : selectedGP4, nome : nomep4, cognome : cognomep4, dataNascita: datanascitap4, noteTurni : notep4},
                        { gradoParentela : selectedGP5, nome : nomep5, cognome : cognomep5, dataNascita: datanascitap5, noteTurni : notep5},
                        { gradoParentela : selectedGP6, nome : nomep6, cognome : cognomep6, dataNascita: datanascitap6, noteTurni : notep6} ]
;

    const data = {
        nomeTitolare : nome,
        cognomeTitolare : cognome,
        cittaResidenzaTitolare : citta,
        indirizzoResidenzaTitolare : via,
        civicoResidenzaTitolare : civico,
        capResidenzaTitolare : cap,
        emailTitolare : email,
        mobileTitolare : mobile,
        ufficioTitolare : ufficio,
        statusTitolare : selectedStatus,
        gradoQualificaTitolare : (grado + qualifica),
        forzaArmataTitolare : (selectedFFAA + selectedAllFFAA),
        sedeTitolare : sede,
        cmdTitolare : numeroCmd,
        nomeConiugeDefunto : nomeConiugeDefunto,
        cognomeConiugeDefunto : cognomeConiugeDefunto,
        tipoDocumentoTitolare : tipoDocumento,
        numeroDocumentoTitolare : numeroDocumento,
        sceltaPrimoTurno : selectedTurno1Altro,
        sceltaSecondoTurno : selectedTurno2Altro,
        prPrimoTurno : selectedTurno1Altropr,
        prSecondoTurno : selectedTurno2Altropr,
        sceltaTurnoAA : selectedTurnoAA,
        dataCongedoTitolare : dataCongedo,
        familiari : familiari,
        numeroAbbonamenti : selectedNAbbonamenti,
        conCabina : selectedCabina
      };

      const dataMail = {
        emailTitolare : email,
        idRichiesta : ""
      };
     
  
      WebAPI.UseCreate( data, function(response) {
        console.log("richiestaAbbonamento response ->" + response.data);
        setSending(0);
        dataMail.idRichiesta =  response.data.richiestaId;
        
        if( response.data.message === "RichiestaAbbonamento created!"){
            window.alert("La richiesta abbonamento è stata inviata con successo! Il codice della tua richiesta è " + response.data.richiestaId + " prendine nota. Una email di riepilogo è stata inviata a " + email);
            window.location.reload();
        } else {
            window.alert("Qualcosa è andato storto....");
        }
      });

     
  }

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleClose = () => {
    window.location.reload();
  }

  const [nome, setNome] = React.useState("");
  const [cognome, setCognome] = React.useState("");
  const [citta, setCitta] = React.useState('');
  const [via, setVia] = React.useState('');
  const [civico, setCivico] = React.useState('');
  const [cap, setCap] = React.useState('');
  const [mobile, setMobile] = React.useState('');
  const [email, setEmail] = React.useState('');
  const [grado, setGrado] = React.useState('');
  const [qualifica, setQualifica] = React.useState('');
  const [sede, setSede] = React.useState('');
  const [ufficio, setTelUfficio] = React.useState('');
  const [nomeConiugeDefunto, setNomeConiugeDefunto] = React.useState('');
  const [cognomeConiugeDefunto, setCognomeConiugeDefunto] = React.useState('');
  const [dataCongedo, setDataCongedo] = React.useState('');

  const [numeroCmd, setNumeroCmd] = React.useState('');
  const [tipoDocumento, setTipoDocumento] = React.useState('');
  const [numeroDocumento, setNumeroDocumento] = React.useState('');

  

  const [nomep1, setNomeP1] = React.useState('');
  const [cognomep1, setCognomeP1] = React.useState('');
  const [datanascitap1, setDataNascitaP1] = React.useState('');
  const [notep1, setNoteP1] = React.useState('');
  
  const [nomep2, setNomeP2] = React.useState('');
  const [cognomep2, setCognomeP2] = React.useState('');
  const [datanascitap2, setDataNascitaP2] = React.useState('');
  const [notep2, setNoteP2] = React.useState('');

  const [nomep3, setNomeP3] = React.useState('');
  const [cognomep3, setCognomeP3] = React.useState('');
  const [datanascitap3, setDataNascitaP3] = React.useState('');
  const [notep3, setNoteP3] = React.useState('');

  const [nomep4, setNomeP4] = React.useState('');
  const [cognomep4, setCognomeP4] = React.useState('');
  const [datanascitap4, setDataNascitaP4] = React.useState('');
  const [notep4, setNoteP4] = React.useState('');


  const [nomep5, setNomeP5] = React.useState('');
  const [cognomep5, setCognomeP5] = React.useState('');
  const [datanascitap5, setDataNascitaP5] = React.useState('');
  const [notep5, setNoteP5] = React.useState('');


  const [nomep6, setNomeP6] = React.useState('');
  const [cognomep6, setCognomeP6] = React.useState('');
  const [datanascitap6, setDataNascitaP6] = React.useState('');
  const [notep6, setNoteP6] = React.useState('');

  const [sending, setSending] = React.useState(0);

  
  const selectStatus = [
    {
    value: "militareinservizio",
    label: "MILITARE IN SERVIZIO PRESSO L'ACCADEMIA AERONAUTICA O ENTE COUBICATO",
    },
    {
    value: "dipcivileinservizio",
    label: "DIP. CIVILE IN SERVIZIO PRESSO L'ACCADEMIA AERONAUTICA O ENTE COUBICATO",
    },
    {
    value: "militareinservizioAEAM",
    label: "MILITARE IN SERVIZIO PRESSO ALTRO ENTE A.M.",
    },
    {
    value: "dipcivileinservizioAEAM",
    label: "DIP. CIVILE IN SERVIZIO PRESSO ALTRO ENTE A.M.",
    },
    {
    value: "coniugesuperstitepersonaleam",
    label: "CONIUGE SUPERSTITE DEL PERSONALE (IN SERVIZIO) MILITARE O CIVILE DELL'A.M.",
    },
    {
    value: "militareinservizioMD",
    label: "MILITARE IN SERVIZIO PRESSO ALTRO ENTE MINISTERO DIFESA",
    },
    {
    value: "dipcivileinservizioMD",
    label: "DIP. CIVILE IN SERVIZIO PRESSO ALTRO ENTE MINISTERO DIFESA",
    },
    {
    value: "militareincongedoAA",
    label: "MILITARE IN CONGEDO GIA' IN FORZA PRESSO L'ACCADEMIA AERONAUTICA",
    },
    {
    value: "dipcivileinquiescenzaAA",
    label: "DIP. CIVILE IN QUIESCENZA GIA' IN FORZA PRESSO L'ACCADEMIA AERONAUTICA",
    },
    {
    value: "militareincongedoMD",
    label: "MILITARE IN CONGEDO GIA' IN FORZA PRESSO ALTRO ENTE MINISTERO DIFESA",
    },
    {
    value: "dipcivileinquiescenzaMD",
    label: "DIP. CIVILE IN QUIESCENZA GIA' IN FORZA PRESSO ALTRO ENTE MINISTERO DIFESA",
    },
    {
    value: "coniugesuperstitealtropersonale",
    label: "CONIUGE SUPERSTITE DEL PERSONALE (CONGEDO O QUIESCENZA) MILITARE O CIVILE DELL'A.M. O DI ALTRO ENTE MINISTERO DIFESA",
    },
    {
    value: "autorita",
    label: "AUTORITA' E PERSONALITA' CON PARTICOLARI TITOLI DI BENEMERENZA DERIVATI DA IMPEGNO PROFESSIONALE O DA RAPPORTO CONTINUATIVO CON L'ACCADEMIA AERONAUTICA",
    },
    {
    value: "personaleDitteAA",
    label: "PERSONALE DITTE/AZIENDE CHE OPERANO CON CONTINUITA' PRESSO L'ACCADEMIA AERONAUTICA",
    }
  ];

  const selectFFAA = [
    {
    value: "AERONAUTICA MILITARE",
    label: "AERONAUTICA MILITARE",
    },
    {
    value: "ESERCITO ITALIANO",
    label: "ESERCITO ITALIANO",
    },
    {
    value: "MARINA MILITARE",
    label: "MARINA MILITARE",
    },
    {
    value: "CARABINIERI",
    label: "CARABINIERI",
    }
  ];

  const selectAllFFAA = [
    {
    value: "AERONAUTICA MILITARE",
    label: "AERONAUTICA MILITARE",
    },
    {
    value: "ESERCITO ITALIANO",
    label: "ESERCITO ITALIANO",
    },
    {
    value: "MARINA MILITARE",
    label: "MARINA MILITARE",
    },
    {
    value: "CARABINIERI",
    label: "CARABINIERI",
    }
  ];

  const selectTurniAA = [
    {
    value: "1° Turno",
    label: "al 1° Turno (dal 1 Luglio al 31 Luglio)",
    },
    {
    value: "2° Turno",
    label: "al 2° Turno (dal 1 Agosto al 31 Agosto)",
    },
    {
        value: "1° e 2° Turno",
        label: "al 1° Turno (dal 1 Luglio al 31 Luglio) e al 2° Turno (dal 1 Agosto al 31 Agosto)",
    }
  ];

  const selectTurniAEAM = [
    {
    value: "yes",
    label: "SI",
    },
    {
    value: "no",
    label: "NO",
    }
  ];

  const selectTurniAEAMpr = [
    {
    value: "1",
    label: "1",
    },
    {
    value: "2",
    label: "2",
    }
  ];

  const selectNAbbonamenti = [
    {
    value: 0,
    label: "0",
    },
    {
    value: 1,
    label: "1",
    },
    {
    value: 2,
    label: "2",
    },
    {
    value: 3,
    label: "3",
    },
    {
    value: 4,
    label: "4",
    },
    {
    value: 5,
    label: "5",
    },
    {
    value: 6,
    label: "6",
    }
  ];

  const selectGP = [
    {
    value: "MARITO",
    label: "MARITO",
    },
    {
    value: "MOGLIE",
    label: "MOGLIE",
    },
    {
    value: "FIGLIO",
    label: "FIGLIO",
    },
    {
    value: "FIGLIA",
    label: "FIGLIA",
    },
    {
    value: "PADRE",
    label: "PADRE",
    },
    {
    value: "MADRE",
    label: "MADRE",
    },
    {
    value: "SUOCERO",
    label: "SUOCERO",
    },
    {
    value: "SUOCERA",
    label: "SUOCERA",
    },
    {
    value: "FRATELLO",
    label: "FRATELLO",
    },
    {
    value: "SORELLA",
    label: "SORELLA",
    },
    {
    value: "CONVIVENTE",
    label: "CONVIVENTE",
    }
  ];

  const [selectedStatus, setSelectedStatus] = React.useState(0);
  const [selectedFFAA, setSelectedFFAA] = React.useState(0);
  const [selectedAllFFAA, setSelectedAllFFAA] = React.useState(0);
  const [selectedTurnoAA, setSelectedTurnoAA] = React.useState(0);
  const [selectedTurno1Altro, setselectedTurno1Altro] = React.useState(0);
  const [selectedTurno1Altropr, setselectedTurno1Altropr] = React.useState(0);
  const [selectedTurno2Altro, setselectedTurno2Altro] = React.useState(0);
  const [selectedTurno2Altropr, setselectedTurno2Altropr] = React.useState(0);
  const [selectedNAbbonamenti, setselectedNAbbonamenti] = React.useState(0);
  const [selectedGP1, setselectedGP1] = React.useState(0);
  const [selectedGP2, setselectedGP2] = React.useState(0);
  const [selectedGP3, setselectedGP3] = React.useState(0);
  const [selectedGP4, setselectedGP4] = React.useState(0);
  const [selectedGP5, setselectedGP5] = React.useState(0);
  const [selectedGP6, setselectedGP6] = React.useState(0);
  const [selectedCabina, setselectedCabina] = React.useState(0);
  
 
  const handleChange = (event) => {

    if(event.target.name == "status"){
      setSelectedStatus(event.target.value);
    }
    if(event.target.name == "forzaArmata"){
        setSelectedFFAA(event.target.value);  
    }
    if(event.target.name == "forzaArmataAll"){
        setSelectedAllFFAA(event.target.value);  
    }
    if(event.target.name == "turno_AA"){
        setSelectedTurnoAA(event.target.value);  
    }
    if(event.target.name == "1_turno_Altro"){
        setselectedTurno1Altro(event.target.value);  
    }
    if(event.target.name == "1_turno_Altro_pr"){
        setselectedTurno1Altropr(event.target.value);  
    }
    if(event.target.name == "2_turno_Altro"){
        setselectedTurno2Altro(event.target.value);  
    }
    if(event.target.name == "2_turno_Altro_pr"){
        setselectedTurno2Altropr(event.target.value);  
    }
    if(event.target.name == "numeroabbonamenti"){
        setselectedNAbbonamenti(event.target.value);  
    }
    if(event.target.name == "grado_parentela_1"){
        setselectedGP1(event.target.value);  
    }
    if(event.target.name == "grado_parentela_2"){
        setselectedGP2(event.target.value);  
    }
    if(event.target.name == "grado_parentela_3"){
        setselectedGP3(event.target.value);  
    }
    if(event.target.name == "grado_parentela_4"){
        setselectedGP4(event.target.value);  
    }
    if(event.target.name == "grado_parentela_5"){
        setselectedGP5(event.target.value);  
    }
    if(event.target.name == "grado_parentela_6"){
        setselectedGP6(event.target.value);  
    }
    if(event.target.name == "cabina"){
        setselectedCabina(event.target.value);  
    }
    
  };

  return (
    <span>
      <Head
        title={"NUOVA RICHIESTA ABBONAMENTO"}
      />
      <Card className={classes.root}>
      <CardContent>
      <Grid container spacing={2}  item xs={12} md={12}>
            <Grid item xs={12} md={12}>
                    <Stepper className={classes.stepper} activeStep={activeStep}>
                        {steps.map((label, index) => {
                        const stepProps = {};
                        const labelProps = {};
                        return (
                            <Step key={label} {...stepProps}>
                            <StepLabel {...labelProps}>{label}</StepLabel>
                            </Step>
                        );
                        })}
                    </Stepper>
                    <Grid container>
                        {getStepContent(
                        handleChange,
                        activeStep,
                        classes,
                        selectedStatus,
                        selectStatus,
                        selectedFFAA, 
                        selectFFAA,
                        selectedAllFFAA, 
                        selectAllFFAA,
                        selectTurniAA, 
                        selectedTurnoAA, 
                        selectTurniAEAM, 
                        selectedTurno1Altro,
                        selectTurniAEAMpr, 
                        selectedTurno1Altropr,
                        selectedTurno2Altro,
                        selectedTurno2Altropr,
                        selectNAbbonamenti, 
                        selectedNAbbonamenti,
                        selectGP, selectedGP1, selectedGP2, selectedGP3, selectedGP4, selectedGP5, selectedGP6,
                        setNome,
                        setCognome,
                        setCitta,
                        setVia,
                        setCivico,
                        setCap, 
                        setMobile, 
                        setEmail, 
                        setTelUfficio,
                        setGrado, 
                        setSede,
                        setQualifica,
                        setNomeConiugeDefunto, 
                        setCognomeConiugeDefunto, 
                        setDataCongedo,
                        setNomeP1, setCognomeP1, setDataNascitaP1,
                        setNomeP2, setCognomeP2, setDataNascitaP2,
                        setNomeP3, setCognomeP3, setDataNascitaP3,
                        setNomeP4, setCognomeP4, setDataNascitaP4,
                        setNomeP5, setCognomeP5, setDataNascitaP5,
                        setNomeP6, setCognomeP6, setDataNascitaP6,
                        nome, cognome, citta, via, civico, cap,
                        mobile, email, grado, qualifica, sede, ufficio, 
                        nomeConiugeDefunto, cognomeConiugeDefunto, dataCongedo,
                        nomep1, cognomep1, datanascitap1, notep1, setNoteP1,
                        nomep2, cognomep2, datanascitap2, notep2, setNoteP2,
                        nomep3, cognomep3, datanascitap3, notep3, setNoteP3,
                        nomep4, cognomep4, datanascitap4, notep4, setNoteP4,
                        nomep5, cognomep5, datanascitap5, notep5, setNoteP5,
                        nomep6, cognomep6, datanascitap6, notep6, setNoteP6,
                        numeroCmd, setNumeroCmd,
                        tipoDocumento, setTipoDocumento,
                        numeroDocumento, setNumeroDocumento,
                        selectedCabina
                        )}
                    </Grid>
            </Grid>
        </Grid>
  
      </CardContent>

      <CardActions>
      <Grid  spacing={2} marging-top={10}>
      {sending === 0 ? (
                 <Grid container spacing={2} className={classes.btnGroup}>
                 <Grid item>
                 <Button
                     variant="outlined"
                     color="secondary"
                     onClick={handleClose}
                 >
                     Annulla
                 </Button>
                 </Grid>
                 {activeStep !== 0 ? (
                 <Grid item>
                     <Button
                     disabled={activeStep === 0}
                     onClick={handleBack}
                     variant="outlined"
                     color="primary"
                     >
                     Indietro
                     </Button>
                 </Grid>
                 ) : null}
                 <Grid item>
                 {activeStep === steps.length - 1 ? (
                     <Button
                     variant="contained"
                     color="primary"
                     onClick={handleSubmit}
                     >
                     Invia
                     </Button>
                 ) : (
                     <Button
                     variant="contained"
                     color="primary"
                     onClick={handleNext}
                     >
                     Successivo
                     </Button>
                 )}
                 </Grid>
             </Grid>
        
            ) : (
                <CircularProgress />
            )}

      </Grid>
 
      </CardActions>  
      </Card>
     </span>
  );
}